import { gsap, Power2 }   from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

document.addEventListener('app:load', init)

function init ()
{
	list()
	popup()
	scrollTo()
	scrollTop()
}

function showPopup (img)
{
	const existingPopup = document.querySelector('#popup')
	
	if (existingPopup)
	{
		existingPopup.remove()
	}
	
	const div = document.createElement('div')
	const divInner = document.createElement('div')
	const divClose = document.createElement('div')
	
	div.id = 'popup'
	divInner.className = 'inner'
	divClose.className = 'close'
	
	divInner.innerHTML = `<figure><img src="${img}"></figure>`
	div.appendChild(divInner)
	div.appendChild(divClose)
	
	document.body.appendChild(div)
	
	setTimeout(() =>
	{
		div.classList.add('visible')
	}, 100)
	
	divClose.addEventListener('click', () =>
	{
		div.remove()
	})
}

function list ()
{
	const list = document.querySelector('section .list')
	
	if (list)
	{
		const listItems = list.querySelectorAll('.item')
		
		listItems.forEach(_ =>
		{
			_.querySelector('.toggle').addEventListener('click', () =>
			{
				_.classList.toggle('open')
				
				gsap.to(_.querySelector('.text'), {
					height: _.classList.contains('open') ? 'auto' : 0,
					// marginTop: _.classList.contains('open') ? '1rem' : 0,
					duration: .5,
					ease: Power2.easeOut
				})
			})
		})
	}
}

function popup ()
{
	const popupLinks = document.querySelectorAll('.popup')
	
	popupLinks.forEach(_ =>
	{
		_.addEventListener('click', (e) =>
		{
			e.preventDefault()
			
			showPopup(e.target.href)
		})
	})
}

function scrollTo ()
{
	const scrollTo = document.querySelectorAll('.scrollto')
	
	scrollTo.forEach(_ =>
	{
		const target = document.querySelector(_.dataset.scrollto).getBoundingClientRect().top - 50
		
		_.addEventListener('click', (e) =>
		{
			e.preventDefault()
			
			gsap.to(window, {
				scrollTo: target,
				duration: 1,
				ease: Power2.easeOut
			})
		})
	})
}

function scrollTop ()
{
	const scrollTop = document.querySelector('#floating-buttons .floating-button-scroll')
	const updateScroll = () =>
	{
		if (window.scrollY > 100)
		{
			scrollTop.classList.add('visible')
		}
		else
		{
			scrollTop.classList.remove('visible')
		}
	}
	
	scrollTop.addEventListener('click', () =>
	{
		gsap.to(window, {
			scrollTo: 0,
			duration: 1,
			ease: Power2.easeOut
		})
	})
	
	window.addEventListener('scroll', () =>
	{
		updateScroll()
	})
	
	updateScroll()
}
